/** Shopify CDN: Minification failed

Line 10:0 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 11:13 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 17:15 Transforming object literal extensions to the configured target environment ("es5") is not supported yet

**/
import '@archetype-themes/scripts/modules/photoswipe'

class ProductImages extends HTMLElement {
  constructor() {
    super();
    this.sectionId = this.closest('[data-section-id]').dataset.sectionId;
    this.initImageZoom();
  }

  initImageZoom() {
    this.photoswipe = new theme.Photoswipe(this, this.sectionId);
  }
}

customElements.define('product-images', ProductImages);
